import axios from '@/axios'
import helper from './helper'

const urlPrefix = 'team-members'

export default {
  export(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`team-members/export/${id}`)
        .then(() => {
          window.location =
            axios.defaults.baseURL + '/admin/download-export/team-members-' + id
          resolve()
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  async getMembers(id) {
    return await helper.get(`${urlPrefix}/membersforentry/${id}`)
  },
  async removeMember(id) {
    return await helper.delete(`${urlPrefix}/${id}`)
  },
  async addMember(member) {
    return await helper.post(`${urlPrefix}`, member);
  },
}
